// extracted by mini-css-extract-plugin
module.exports = {"matrix":"Next_matrix__1dz8V","row":"Next_row__2NyQl"};